import { TemplateRef } from '@angular/core';
import { of } from "rxjs";
import * as i0 from "@angular/core";
var CsDropDownService = /** @class */ (function () {
    function CsDropDownService() {
    }
    CsDropDownService.prototype.registerDdTemplates = function (togglerRef, itemRef) {
        // Register new Toggler-templates here :
        this.togglerTemplates = {
            BTN_TRANSPARENT: togglerRef.btnTransparent,
            BTN_PRIMARY: togglerRef.btnPrimary
        };
        // Register new Item-templates here :
        this.itemTemplates = {
            BASIC: itemRef.basicTemplate
        };
        return of({
            togglersHolder: this.togglerTemplates,
            itemsHolder: this.itemTemplates
        });
    };
    CsDropDownService.prototype.resetDdItemList = function (ddConfig, itemList, group) {
        var _this = this;
        itemList.forEach(function (item) { return _this.setItemConfig(ddConfig, item, group); });
        group ? (group.items = itemList) : (ddConfig.ddMenuConfig.items = itemList);
        ddConfig.ddMenuConfig.totalItemsCount = this.getItemsBy(ddConfig, 'ALL').length;
        ddConfig.ddMenuConfig.selectedItemsCount = this.getItemsBy(ddConfig, 'SELECTED').length;
    };
    CsDropDownService.prototype.setItemConfig = function (ddConfig, item, group) {
        item.ddConfigId = ddConfig.id;
        item.ddGroupId = (group && group.id) || null;
        // item.filterId = item.id || null;
        item.itemTemplateType = item.itemTemplateType || (group && group.templateType) || ddConfig.ddMenuConfig.templateType;
        item.itemCustomTemplateRef = item.itemCustomTemplateRef || (group && group.customTemplateRef) || ddConfig.ddMenuConfig.customTemplateRef || null;
        item.isMultiChoiceItem = (group && group.isMultiChoice) || ddConfig.ddMenuConfig.isMultiChoice || null;
        item.indicatorIcon = (item.templateData['iconsList'] && item.templateData['iconsList'].find(function (icon) { return icon.isItemIndicator; })) || null;
    };
    CsDropDownService.prototype.getItemsBy = function (ddConfig, getOnly) {
        var allItemList = [];
        // Load all items to `allItemList` :
        if (ddConfig.ddMenuConfig.isGroupItem) {
            ddConfig.ddMenuConfig.groupItems.forEach(function (group) {
                allItemList.push.apply(allItemList, group.items);
            });
        }
        else {
            allItemList = ddConfig.ddMenuConfig.items;
        }
        // Filter items by given constraint :
        if (getOnly === 'SELECTED') {
            allItemList = allItemList.filter(function (item) { return item.isSelected; });
        }
        else if (getOnly === 'ENABLED') {
            allItemList = allItemList.filter(function (item) { return !item.isHide; });
        }
        return allItemList;
    };
    CsDropDownService.ngInjectableDef = i0.defineInjectable({ factory: function CsDropDownService_Factory() { return new CsDropDownService(); }, token: CsDropDownService, providedIn: "root" });
    return CsDropDownService;
}());
export { CsDropDownService };
